import { Check, Circle, Clock, Trash2 } from "lucide-react";
import PriorityBadge from "@/components/PriorityBadge";
import { Link } from "react-router-dom";

export default function TaskRow({ task, collaborator, onToggle, onDelete, showCollaborator = false }) {
  const done = task.status === "done";
  const overdue = task.due_date && task.due_date < new Date().toISOString().slice(0, 10) && !done;

  return (
    <div
      data-testid={`task-row-${task.id}`}
      className={`group flex items-start gap-3 py-3 px-3 border-b border-line last:border-b-0 hover:bg-surface-secondary transition-colors ${done ? "opacity-60" : ""}`}
    >
      <button
        data-testid={`task-toggle-${task.id}`}
        onClick={() => onToggle?.(task)}
        className="mt-0.5 shrink-0"
        aria-label="Označi kao završeno"
      >
        {done ? (
          <div className="w-5 h-5 rounded-full bg-forest grid place-items-center">
            <Check className="w-3 h-3 text-white" strokeWidth={3} />
          </div>
        ) : (
          <Circle className="w-5 h-5 text-ink-muted hover:text-forest" />
        )}
      </button>

      <div className="flex-1 min-w-0">
        <div className={`text-sm font-medium ${done ? "line-through text-ink-muted" : "text-ink"}`}>
          {task.title}
        </div>
        {task.description ? (
          <div className="text-xs text-ink-muted mt-0.5 line-clamp-2">{task.description}</div>
        ) : null}
        <div className="flex flex-wrap items-center gap-2 mt-1.5">
          <PriorityBadge priority={task.priority} />
          {task.due_date ? (
            <span className={`inline-flex items-center gap-1 text-xs ${overdue ? "text-terracotta font-semibold" : "text-ink-muted"}`}>
              <Clock className="w-3 h-3" />
              {task.due_date}
            </span>
          ) : null}
          {showCollaborator && collaborator ? (
            <Link
              to={`/saradnici/${collaborator.id}`}
              className="text-xs text-forest hover:underline"
              data-testid={`task-collab-link-${task.id}`}
            >
              {collaborator.name}
            </Link>
          ) : null}
        </div>
      </div>

      {onDelete ? (
        <button
          data-testid={`task-delete-${task.id}`}
          onClick={() => onDelete(task)}
          className="opacity-0 group-hover:opacity-100 transition-opacity text-ink-muted hover:text-terracotta"
          aria-label="Obriši"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      ) : null}
    </div>
  );
}
